(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["looping-product-carousel"] && !Shopify.designMode) return;
  try {
    
  class LoopingCarousel {
    constructor(el) {
      this.el = el;
      this.track = el.querySelector('[data-carousel-track]');
      this.slides = Array.from(el.querySelectorAll('[data-carousel-slide]'));
      this.prevBtn = el.querySelector('[data-carousel-prev]');
      this.nextBtn = el.querySelector('[data-carousel-next]');
      // Dots sit outside the carousel element, inside the section
      this.dotsContainer = el.parentElement.querySelector('[data-carousel-dots]');

      if (!this.track || this.slides.length === 0) return;

      this.currentPage = 0;
      this.isProgrammaticScroll = false;

      this.computeLayout();
      this.buildDots();
      this.bindEvents();
      this.updateActiveDot();

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.computeLayout();
          this.buildDots();
          this.updateActiveDot();
        }, 150);
      });
    }

    computeLayout() {
      const firstSlide = this.slides[0];
      const slideRect = firstSlide.getBoundingClientRect();
      const trackRect = this.track.getBoundingClientRect();
      const gap =
        parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;

      this.slideStep = slideRect.width + gap;
      this.visibleCount = Math.max(1, Math.round((trackRect.width + gap) / this.slideStep));
      this.totalPages = Math.max(1, Math.ceil(this.slides.length / this.visibleCount));

      const fitsAll = this.slides.length <= this.visibleCount;
      if (this.prevBtn) this.prevBtn.hidden = fitsAll;
      if (this.nextBtn) this.nextBtn.hidden = fitsAll;
      if (this.dotsContainer) this.dotsContainer.hidden = fitsAll;

      if (this.currentPage >= this.totalPages) {
        this.currentPage = this.totalPages - 1;
      }
    }

    buildDots() {
      if (!this.dotsContainer) return;
      this.dotsContainer.innerHTML = '';
      for (let i = 0; i < this.totalPages; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'looping-carousel__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Go to slide ${i + 1} of ${this.totalPages}`);
        dot.addEventListener('click', () => this.goToPage(i));
        this.dotsContainer.appendChild(dot);
      }
    }

    goToPage(pageIndex, smooth = true) {
      this.currentPage = pageIndex;
      const targetIndex = Math.min(
        pageIndex * this.visibleCount,
        Math.max(0, this.slides.length - this.visibleCount)
      );
      const targetSlide = this.slides[targetIndex];
      if (!targetSlide) return;

      this.isProgrammaticScroll = true;
      this.track.scrollTo({
        left: targetSlide.offsetLeft - this.track.offsetLeft,
        behavior: smooth ? 'smooth' : 'auto',
      });

      this.updateActiveDot();

      clearTimeout(this._scrollFlagTimer);
      this._scrollFlagTimer = setTimeout(() => {
        this.isProgrammaticScroll = false;
      }, 700);
    }

    next() {
      // Manual loop: wrap to first page after last
      const nextPage = (this.currentPage + 1) % this.totalPages;
      this.goToPage(nextPage);
    }

    prev() {
      // Manual loop: wrap to last page before first
      const prevPage = (this.currentPage - 1 + this.totalPages) % this.totalPages;
      this.goToPage(prevPage);
    }

    updateActiveDot() {
      if (!this.dotsContainer) return;
      const dots = this.dotsContainer.querySelectorAll('.looping-carousel__dot');
      dots.forEach((dot, i) => {
        const active = i === this.currentPage;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    bindEvents() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());

      // Sync active dot when user swipes / scrolls manually
      let syncTimer;
      this.track.addEventListener('scroll', () => {
        if (this.isProgrammaticScroll) return;
        clearTimeout(syncTimer);
        syncTimer = setTimeout(() => {
          const scrollLeft = this.track.scrollLeft;
          const index = Math.round(scrollLeft / this.slideStep);
          const page = Math.min(this.totalPages - 1, Math.floor(index / this.visibleCount));
          if (page !== this.currentPage && page >= 0) {
            this.currentPage = page;
            this.updateActiveDot();
          }
        }, 120);
      });

      // Keyboard navigation when track is focused
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.prev();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.next();
        }
      });
    }
  }

  function initLoopingCarousels() {
    document.querySelectorAll('[data-looping-carousel]').forEach((el) => {
      if (!el.__loopingCarouselInit) {
        el.__loopingCarouselInit = true;
        new LoopingCarousel(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoopingCarousels);
  } else {
    initLoopingCarousels();
  }

  // Re-initialize inside the Shopify theme editor
  document.addEventListener('shopify:section:load', initLoopingCarousels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
